import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../environments/environment';
import { SERVICES } from '../constants/services';
import { Triple, UserModel } from './UserModel';
import { BackendDataService } from '../services/backendDataService/backendDataService';


export class ClientFilter{
    filter: {
        sapCode:string,
        customerName:string,
        address:string,
        city:string,
        zipCode:string,
        countryCode: string,
        distrCh:string,
        salesOrg:string,
        isProspect:boolean
    };
    search:string;
    offset:number;
    limit:number;
    sortBy:string;
    sortOrder:string;
}
export const ClientType={
    PROSPECT:'P',
    SAP:'S'
}

export class NewClientModel{
    customerName: string;
    contactName:string;
    countryCode:string;
    city:string;
    salesOrg:string;
    sales_org_dist:string;
    distrCh:string;
    contactEmail:string;
    contactPhone:string;
    creationDate:string;
    _id: string;
}

@Injectable()
export class ClientModel{
    sapCode:string;
    customerClass: string;
    customerName:string;
    address:string;
    email:string;
    city:string;
    zipCode:string;
    countryCode:string;
    type: string;
    specialBrands: Array<string>;
    salesData: Triple;
    idClient:string;

    constructor(private http: HttpClient, private userModel: UserModel, public backend:BackendDataService){

    };
    init(obj:any={}) {
        Object.assign(this, obj);

    }

   

    async getClients(filters:ClientFilter):Promise<Array<ClientModel>> {
        let list: Array<ClientModel> = [];
        
        
        filters.filter.distrCh = this.userModel.currentDivision.distrCh;
        filters.filter.salesOrg = this.userModel.currentDivision.salesOrg;
        filters.filter.countryCode = this.userModel.currentDivision.countryCode;
        await this.backend.request(SERVICES["CLIENTS"].list,filters).then((data:Array<ClientModel>) => {
            list = data;
        }).catch((error) => {
            console.log(error);
        })
        return list;
    }
    

    async countClients(filters:ClientFilter){
        let count:number = 0;
        
        filters.filter.distrCh = this.userModel.currentDivision.distrCh;
        filters.filter.salesOrg = this.userModel.currentDivision.salesOrg;
        filters.filter.countryCode = this.userModel.currentDivision.countryCode;
        await this.backend.request(SERVICES["CLIENTS"].count,filters).then((data:number) => {
            count = data["count"];
        }).catch((error) => {
            console.log(error);
        })
        return count;
    }

    async createNewClient(client:NewClientModel) {
        let response:NewClientModel;
        await this.backend.request(SERVICES["CLIENTS"].save, client).then((data: NewClientModel) => {
            response = data;
        }).catch((error) => {
            console.log(error);
            response = null;
        })
        return response;
    }

    async getClient(idClient) {
    
        var data = await this.backend.get(SERVICES["CLIENTS"].get+"/"+idClient);
        if(data)
        {
          data.idClient=idClient;
          data.type=idClient.length>15?ClientType.PROSPECT:ClientType.SAP;
        }
        
    
        return data ;
    
      }

}